import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/default-landing-header-image.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/news/article/ui/NewsArticlePage.tsx");
